import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { servicePlanItemsMessages } from 'src/features/servicePlanItems/utils/messages';
import { servicePlanTermsMessages } from 'src/features/servicePlanTerms/utils/messages';
import { ServicePlanTabContext } from 'src/features/servicePlans/utils/tabContext';

type ServicePlanDashboardTablesProps = {
    isServicePlanActive?: boolean;
};

const ServicePlanDashboardTables = ({ isServicePlanActive }: ServicePlanDashboardTablesProps) => {
    return (
        <div className="grid flex-3 grid-cols-1">
            <TabRow>
                <Tab to="items" preventScrollReset>
                    <FormattedMessage {...servicePlanItemsMessages.servicePlanItems} />
                </Tab>
                <Tab to="terms" preventScrollReset>
                    <FormattedMessage {...servicePlanTermsMessages.servicePlanTerms} />
                </Tab>
            </TabRow>
            <div className="mt-4">
                <Outlet context={{ isServicePlanActive } satisfies ServicePlanTabContext} />
            </div>
        </div>
    );
};

export default ServicePlanDashboardTables;
